import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

export const demoMode = import.meta.env.VITE_DEMO_MODE === "true";
export const workspaceId = (import.meta.env.VITE_WORKSPACE_ID as string | undefined) || "";
export const fileApiUrl = (import.meta.env.VITE_FILE_API_URL as string | undefined) || "";
export const configured = Boolean(url && anonKey && workspaceId);

export const supabase = url && anonKey
  ? createClient(url, anonKey, {
      auth: { flowType: "pkce", persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
    })
  : null;
